const japanese = {
  id: 'ID',
  anAdvertiserId: '広告主Id',
  advertiserName: '広告主名',
  name: '名前',
  code: 'コード',
  staffName: 'スタッフ名',
  manager: '管理者',
  email: 'メールアドレス',
  tel: '電話番号',
  agencyName: '代理店名',
  agencyId: '代理店ID',
  status: 'ステータス',
  systemOwnerId: 'システムオーナー ID',
  actions: '編集/削除',
  menuName: 'メニュー名',
  priority: '優先度',
  unitType: '課金形態',
  unitPrice: '配信単価',
  resourceType: '使用可能範囲',
  resourceDateRange: '使用可能期間',
  listName: 'リスト名称',
  resourceName: '所属',
  blackOrWhite: '種別',
  ipRangeCount: '登録数',
  ipFrom: '開始IP',
  ipTo: '終了IP',
  belongType: {
    oem: 'OEM',
    agency: '代理店',
    advertiser: '広告主',
    'system owner': 'システムオーナー',
  },
  userType: {
    'super admin': 'SuperAdmin',
    'system operator': 'システム管理者',
    administrator: '管理者',
    'operator manager': '運用管理者',
    operator: '運用',
    'sales manager': '営業マネージャー',
    sales: '営業',
  },
}

export default japanese
